import { TaskPage } from '@/modules/tasks/components/task-page'
import { TaskModule } from '@/modules/tasks/task-module'

export const TasksView = () => {
  return (
    <TaskModule>
      <TaskPage />
    </TaskModule>
  )
}
